// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function Assets(props) {
  const { proposalUid, blocked, hasRights } = props;
  return (
    <ProjectContentDescription
      title="Actifs de la société"
      tooltip={Tooltip.ProjectOfferAssets.description}
      proposalUid={proposalUid}
      hasRights={hasRights}
      blocked={blocked}
    />
  );
}

Assets.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

Assets.defaultProps = {
  proposalUid: undefined
};
